import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-2019"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "图层_1" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.08 9.375a.855.855 0 0 0-.701.321c-.173.214-.26.485-.26.813 0 .33.086.602.258.814.172.213.406.319.702.319.299 0 .533-.106.704-.317s.256-.484.256-.816c0-.337-.085-.61-.255-.819-.168-.211-.403-.315-.704-.315zm0 1.855c-.314 0-.472-.241-.472-.723s.157-.723.472-.723c.314 0 .472.241.472.723-.001.483-.158.723-.472.723zM7.012 8.18c.171-.211.256-.484.256-.816 0-.337-.085-.61-.254-.819-.17-.209-.405-.314-.706-.314-.294 0-.528.107-.701.321s-.26.485-.26.813c0 .33.086.602.258.814.172.213.406.319.702.319.299 0 .534-.106.705-.318zm-1.176-.816c0-.482.157-.723.472-.723s.472.241.472.723-.157.723-.472.723-.472-.241-.472-.723zm3.486-1.091a.29.29 0 0 0-.398.097l-2.955 4.831a.29.29 0 0 0 .247.44.286.286 0 0 0 .247-.139l2.955-4.831a.289.289 0 0 0-.096-.398z",
    class: "st6"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.694.214S2.503 7.726 2.503 10.595s2.322 5.19 5.191 5.19c2.869 0 5.191-2.321 5.191-5.19S7.694.214 7.694.214zm2.954 11.819c-.396.008-.623.08-1.465.351l-.12.038c-.576.23-1.055.355-1.346.355-.49 0-1.298-.338-1.306-.342l-.164-.054c-.883-.283-1.093-.35-1.446-.354-.322 0-.645.053-.985.16a4.073 4.073 0 0 1-.345-1.624c0-1.581 2.236-5.592 4.221-8.66 1.985 3.069 4.222 7.081 4.222 8.66 0 .545-.115 1.089-.342 1.618a3.249 3.249 0 0 0-.924-.148z",
    class: "st6"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }